module.exports = __webpack_public_path__ + "img/Flunder_12.3fab6fea.png";